// create a context to parse animation filenames at build time
// sanitize the keys from '/ambulance.json' to 'ambulance'
const context = require.context('./', false, /\.json$/)
export const animations = context
  .keys()
  .map((k) => k.replace(/^\.\/(.+)\.json$/, '$1'))
